<template>
  <div>
    <div :class="`wrapper-page${isMenuOpen ? '' : '-closeSidebar'}`">
      <!-- Mobile -->
      <PageSidebarMobile :show="isMenuOpen && currentDevice != 'desktop'" />

      <!-- Desktop -->
      <page-sidebar
        :isMenuOpen="isMenuOpen"
        :tooltipType="tooltipType"
        @toggleMenu="toggleMenu"
        v-if="currentDevice == 'desktop'"
      >
        <template #custom-header>
          <img
            src="@/core/assets/images/layout/logo-admin.png"
            alt="Razzil"
            class="sidebar-logo"
          />
          <span class="sidebar-title w-50">Crystal</span>
        </template>

        <template #list-items>
          <router-link
            :to="{ name: 'dashboard' }"
            tag="li"
            exact-active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'home-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-home-5-line"></i>
              </span>

              <span class="sidebar-item-text">Portada</span>

              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'home-item'"
                text="Portada"
              />
            </div>
          </router-link>

          <!-- Colaboradores -->
          <router-link
            :to="{ name: 'employee-list' }"
            tag="li"
            active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'employee-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-file-user-line"></i>
              </span>

              <span class="sidebar-item-text">Colaboradores</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'employee-item'"
                text="Colaboradores"
              />
            </div>
          </router-link>

          <!-- Contratos -->
          <router-link
            :to="{ name: 'contracts-list' }"
            tag="li"
            active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'contract-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-file-list-line"></i>
              </span>

              <span class="sidebar-item-text">Contratos</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'contract-item'"
                text="Contratos"
              />
            </div>
          </router-link>

          <!-- Vacaciones -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/vacaciones"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'vacations'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('vacations')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'vacations-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-calendar-check-line"></i>
                  </span>

                  <span class="sidebar-item-text">Vacaciones</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'vacations-item'"
                    text="Vacaciones"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('vacations') ? 'active' : ''
                }`"
              >
                Solicitudes
              </span>
            </div>
            <div v-if="isMenuOpen">
              <SidebarArrowTopIcon v-if="isCurrent('vacations')" />
              <SidebarArrowBottomIcon v-else />
            </div>
          </router-link>

          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('vacations') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="vacation-requests-list"
                text="Solicitudes"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="vacation-calendar"
                text="Calendario"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="vacation-history"
                text="Historial"
              ></sub-item>
            </ul>
          </section>

          <!-- [HIDDEN-DEV] Descansos médicos
          <router-link
            :to="{ name: 'medical-leave-list' }"
            tag="li"
            active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'medical-leave-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-heart-pulse-line"></i>
              </span>
              <span class="sidebar-item-text">Descansos médicos</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'medical-leave-item'"
                text="Descansos médicos"
              />
            </div>
          </router-link>
          [/HIDDEN-DEV] -->

          <!-- [HIDDEN-DEV] Asistencia
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/asistencia"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'attendance'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('attendance')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'attendance-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-time-line"></i>
                  </span>

                  <span class="sidebar-item-text">Asistencia</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'attendance-item'"
                    text="Asistencia"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('attendance') ? 'active' : ''
                }`"
              >
                Control, Resumen
              </span>
            </div>
            <div v-if="isMenuOpen">
              <SidebarArrowTopIcon v-if="isCurrent('attendance')" />
              <SidebarArrowBottomIcon v-else />
            </div>
          </router-link>

          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('attendance') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="attendance-grid"
                text="Control mensual"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="attendance-summary"
                text="Resumen"
              ></sub-item>
            </ul>
          </section>
          [/HIDDEN-DEV] -->

          <!-- [HIDDEN-DEV] Desc. y adicionales
          <router-link
            :to="{ name: 'payroll-movement-list' }"
            tag="li"
            active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'movement-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-exchange-dollar-line"></i>
              </span>

              <span class="sidebar-item-text">Desc. y adicionales</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'movement-item'"
                text="Desc. y adicionales"
              />
            </div>
          </router-link>
          [/HIDDEN-DEV] -->

          <!-- [HIDDEN-DEV] Planillas
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/payroll"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'payroll'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('payroll')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'payroll-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-money-dollar-circle-line"></i>
                  </span>

                  <span class="sidebar-item-text">Planillas</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'payroll-item'"
                    text="Planillas"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('payroll') ? 'active' : ''
                }`"
              >
                Lista, Carga
              </span>
            </div>
            <div v-if="isMenuOpen">
              <SidebarArrowTopIcon v-if="isCurrent('payroll')" />
              <SidebarArrowBottomIcon v-else />
            </div>
          </router-link>

          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('payroll') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-list"
                text="Lista"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-base-batch"
                text="Carga de planillas"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-status-made-batch-list"
                text="Cargar abonos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-type-list"
                text="Tipos de planilla"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-engine"
                text="Motor (prueba)"
              ></sub-item>
            </ul>
          </section>
          [/HIDDEN-DEV] -->

          <!-- [HIDDEN-DEV] Reclutamiento
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/recruitment"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'recruitment'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('recruitment')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'recruitment-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-rocket-line"></i>
                  </span>

                  <span class="sidebar-item-text">Reclutamiento</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'recruitment-item'"
                    text="Reclutamiento"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('recruitment') ? 'active' : ''
                }`"
              >
                Vacantes
              </span>
            </div>
            <div v-if="isMenuOpen">
              <SidebarArrowTopIcon v-if="isCurrent('recruitment')" />
              <SidebarArrowBottomIcon v-else />
            </div>
          </router-link>

          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('recruitment') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="job-openings-list"
                text="Vacantes"
              ></sub-item>
            </ul>
          </section>
          [/HIDDEN-DEV] -->

          <!-- Mantenimiento -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/config"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'config'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('config')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'config-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-settings-3-line"></i>
                  </span>

                  <span class="sidebar-item-text">Mantenimiento</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'config-item'"
                    text="Mantenimiento"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('config') ? 'active' : ''
                }`"
              >
                Áreas, Empresas
              </span>
            </div>
            <div v-if="isMenuOpen">
              <SidebarArrowTopIcon v-if="isCurrent('config')" />
              <SidebarArrowBottomIcon v-else />
            </div>
          </router-link>

          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('config') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="company-list"
                text="Empresas"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="work-site-list"
                text="Sedes"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="bank-list"
                text="Bancos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="payroll-concept-list"
                text="Conceptos remunerativos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="area-list"
                text="Áreas"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="roles-list"
                text="Cargos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="channel-list"
                text="Canales"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="expense-line-list"
                text="Líneas de gasto"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="pension-entity-list"
                text="Entidades pensionarias"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="document-type-list"
                text="Tipos de documento"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="legal-parameter-list"
                text="Parámetros legales"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="work-schedule-list"
                text="Horarios"
              ></sub-item>
            </ul>
          </section>

          <router-link
            :to="{ name: 'audit-log' }"
            tag="li"
            exact-active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'audit-log'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-edit-line"></i>
              </span>

              <span class="sidebar-item-text">Auditoría</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'audit-log'"
                text="Auditoría"
              />
            </div>
          </router-link>
        </template>
      </page-sidebar>

      <div class="wrapper-page__content">
        <page-header />
        <div class="wrapper-page__inner">
          <b-container fluid>
            <slot></slot>
          </b-container>
        </div>
      </div>

      <page-footer />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import {
  PageSidebar,
  SubItem,
  CustomTooltip,
  SidebarArrowBottomIcon,
  SidebarArrowTopIcon,
  PageFooter,
} from "wize-admin";

import PageHeader from "./PageHeader";
import PageSidebarMobile from "./layout/PageSidebarMobile";

export default {
  name: "PageBase",
  components: {
    PageHeader,
    PageSidebar,
    PageFooter,
    CustomTooltip,
    SubItem,
    SidebarArrowBottomIcon,
    SidebarArrowTopIcon,
    PageSidebarMobile,
  },
  data() {
    return {
      matchMediaMd: window.matchMedia("(max-width: 768px)"),
      tooltipType: null,
    };
  },
  mounted() {
    this.calcResize();
  },
  computed: {
    ...mapGetters({
      currentSubmenu: "app/getCurrentSubmenu",
      isMenuOpen: "app/isMenuOpen",
      currentDevice: "app/getCurrentDevice",
    }),
  },
  methods: {
    ...mapMutations({
      setCurrentSubmenu: "app/setCurrentSubmenu",
      setMenu: "app/setMenu",
      toggleMenu: "app/toggleMenu",
    }),
    setCurrentDevice() {
      if (screen.width < 992) {
        this.$store.commit("app/setCurrentDevice", "mobile");
        this.toggleMenu(false);
      } else {
        this.$store.commit("app/setCurrentDevice", "desktop");
        this.toggleMenu(true);
      }
    },
    calcResize() {
      this.setCurrentDevice();

      this.lastWidth = window.innerWidth;

      window.addEventListener("resize", () => {
        const currentWidth = window.innerWidth;

        if (currentWidth !== this.lastWidth) {
          this.setCurrentDevice();
          this.lastWidth = currentWidth;
        }
      });
    },
    isMatchMedia() {
      if (this.matchMediaMd.matches) {
        this.setMenu(false);
      } else {
        this.setMenu(true);
      }
    },
    isCurrent(submenu) {
      return this.currentSubmenu.includes(submenu);
    },
  },
  created() {
    this.matchMediaMd.addListener(this.isMatchMedia);
  },
};
</script>

<style scoped lang="stylus"></style>
